module.exports = __webpack_public_path__ + "img/m4.e654f791.jpg";